import Layout from "@/layout";
export default {
  path: "SupplierManagement",
  // component: Layout,
//   redirect: "/HeadOfficeManagement/Home/HomeIndexPage",
  component: () => import('@/views/AppMain/index'),
  // component: () => import("@/views/Advertisement/Home/Home"),
  name: "SupplierManagement",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "供应商管理",
    keepAlive: false,
    icon: '1045',
    activeIcon: '1046',
    // activeMenu: '/UrbanIntegration/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "SupplierManagementList",
      component: () => import("@/views/HeadOfficeManagement/SupplierManagement/SupplierManagementList"),
      // redirect: "",
      name: "SupplierManagementList",
      meta: {
        title: "供应商列表",
        //   icon: 'homeIndexPage',
        keepAlive: true,
      }
    },
  ]
};
